export const modalZIndex = 1010;
export const APP_MIN_WIDTH = 1024;
// STANDARD_IMAGE_ASPECT is the standard image aspect ratio for images
//  that gaia uses - it is height of image / width of image
export const STANDARD_IMAGE_ASPECT = 0.75;
